<template>
  <div>
    <Header headerTitle="发票订单列表" :hasBackBtn="true"></Header>
    <div class="main-container">
      <section style="margin-bottom:20px;" v-if="resultList!=''">
        <div class="headerInfo items" v-for="(item,index) in resultList" :key="index">
          <div class="radios">
            <h6>
              {{item.parkingName}}
              <span v-if="item.status==1">待支付</span>
              <span v-if="item.status==2" style="color:#cc9502">待进场</span>
              <span v-if="item.status==3">已进场</span>
              <span v-if="item.status==4">已取消</span>
              <span v-if="item.status==5" style="color:#c30808">超时待支付</span>
              <span v-if="item.status==6" style="color:#008aac">已完成</span>
              <span v-if="item.status==7" style="color:#c30808">支付超时取消</span>
            </h6>
            <p>
              预约进场时间:{{item.appointInTime}}
              <span style="color:#666;">&nbsp;{{item.orderAmount}}元</span>
            </p>
            <p>预约时长：{{item.appointTime}}小时</p>
          </div>
        </div>
      </section>
      <div v-if="resultList==''">暂无订单</div>
    </div>
    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>
  </div>
</template>
<script>
import { orderList } from "../../api/order.js";
export default {
  name: "OrderInvoicingList",
  data() {
    return {
      resultList: [], //数据
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "" //提示类型
    };
  },
  methods: {
    //页面加载的数据
    loadOrderList: function() {
      orderList({ orderIds: this.$route.params.orderIds }).then(
        response => {
          if (response.data.status == 200) {
            this.resultList = response.data.result;
          } else {
            this.tipShow = "1" + Math.random() * 1000;
            this.message = response.data.message;
            this.tipType = "warning";
          }
        },
        err => {
          reject(err);
        }
      );
    }
  },
  //加载事件
  created() {
    this.loadOrderList(); //订单Id
  }
};
</script>
<style>
section .radios {
  margin-bottom: 6px;
}
section .headerInfo .radios {
  text-align: left;
}
section .headerInfo .custom-control {
  width: 100%;
}
section .headerInfo label {
  width: 100%;
}
section .headerInfo .radios p span {
  display: inline-block;
  float: right;
  font-size: 13px;
  color: #f5c265;
}
section .headerInfo .radios h6 span {
  display: inline-block;
  float: right;
  font-size: 13px;
  color: #f5c265;
}
section .headerInfo .buttoms {
  text-align: right;
}
section .items {
  margin-top: 10px;
  border-top: 8px solid #e9e9e9;
  padding: 10px;
}
section .headerInfo a {
  background-color: #0066B1;
  padding: 5px 25px;
  text-align: center;
  border: 0px;
}
section .headerInfo a:link {
  background-color: #0066B1;
}
section .headerInfo .radios p span b {
  border: #f5c265 solid 1px;
  border-radius: 2px;
  font-size: 11px;
}
section .headerInfo .radios p {
  font-size: 14px;
  color: #666;
}
section button {
  background-color: #0066B1;
  color: #fff;
  width: 28%;
}
</style>


      